var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-table',{ref:"tableDataId",attrs:{"border":"","align":"center","data":_vm.tableData}},_vm._l((_vm.list),function(item,index){return _c('vxe-table-column',{key:item.key,attrs:{"field":item.val,"title":item.name}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }